import BaseApi, { BaseApiResponse } from '@lumapps/base-api';
import { NavigationMap } from '@lumapps/navigation/types';

import { sanitizeNavigationMapForUpdate } from '../utils';

export const mainNavigationApi = new BaseApi({
    version: BaseApi.versions.v2,
    // force direct call to Haussmann navigation service instead of passing it trough GAE
    bypassMonolith: true,
});

/**
 * Get the navigation-maps which is used in the navigation administration
 */
export const getMainNavigationMaps = (siteId: string, languages: string): Promise<BaseApiResponse<NavigationMap>> => {
    return mainNavigationApi.get(`sites/${siteId}/navigation-maps/main`, {
        headers: {
            'Accept-Language': languages,
        },
    });
};

/**
 * Update the navigation-maps. Takes the whole navigationMap, then sanitize it before sending to the back.
 * The endpoint will return the updated navigationMap
 */
export const updateMainNavigationMaps = (
    siteId: string,
    newNavigationMap: NavigationMap,
    languages: string,
): Promise<BaseApiResponse<NavigationMap>> => {
    return mainNavigationApi.put(
        `sites/${siteId}/navigation-maps/main`,
        sanitizeNavigationMapForUpdate(newNavigationMap, { removeEmptySectionChildren: false }),
        {
            headers: {
                'Accept-Language': languages,
            },
        },
    );
};
